<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="活动名称">
                <a-input v-model="queryParam.name" placeholder="请输入活动名称" allow-clear @press-enter="handleQuery" />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="活动类型">
                <a-select v-model="queryParam.activityType" placeholder="请选择活动类型" allow-clear>
                  <a-select-option v-for="item in activityTypeOptions" :key="item.value" :value="item.value">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="状态">
                <a-select v-model="queryParam.status" placeholder="请选择状态" allow-clear>
                  <a-select-option :value="1">启用</a-select-option>
                  <a-select-option :value="0">停用</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="24" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['coupon:couponActivity:add']">
          <a-icon type="plus" />新增
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['coupon:couponActivity:edit']">
          <a-icon type="edit" />修改
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['coupon:couponActivity:remove']">
          <a-icon type="delete" />删除
        </a-button>
        <table-setting
          :style="{ float: 'right' }"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList"
        />
      </div>

      <create-form ref="createForm" @ok="getList" />

      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="activityType" slot-scope="text">
          <a-tag color="blue">{{ getActivityTypeLabel(text) }}</a-tag>
        </span>
        <span slot="startTime" slot-scope="text">
          {{ formatDateTime(text) }}
        </span>
        <span slot="endTime" slot-scope="text">
          {{ formatDateTime(text) }}
        </span>
        <span slot="status" slot-scope="text">
          <a-tag :color="Number(text) === 1 ? 'green' : 'red'">
            {{ Number(text) === 1 ? '启用' : '停用' }}
          </a-tag>
        </span>
        <span slot="createTime" slot-scope="text">
          {{ formatDateTime(text) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['coupon:couponActivity:edit']">
            <a-icon type="edit" />修改
          </a>
          <a-divider type="vertical" v-hasPermi="['coupon:couponActivity:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['coupon:couponActivity:remove']">
            <a-icon type="delete" />删除
          </a>
        </span>
      </a-table>

      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="value => `共 ${value} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageCouponActivity, delCouponActivity } from '@/api/coupon/couponActivity'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

const ACTIVITY_TYPE_OPTIONS = [
  { label: '新用户注册', value: 'NEW_USER_REGISTER' }
]

export default {
  name: 'CouponActivity',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      single: true,
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      activityTypeOptions: ACTIVITY_TYPE_OPTIONS,
      queryParam: {
        name: undefined,
        activityType: undefined,
        status: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '活动名称',
          dataIndex: 'name',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '优惠券名称',
          dataIndex: 'couponName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '优惠券金额',
          dataIndex: 'couponPrice',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '活动类型',
          dataIndex: 'activityType',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'activityType' }
        },
        {
          title: '开始时间',
          dataIndex: 'startTime',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'startTime' }
        },
        {
          title: '结束时间',
          dataIndex: 'endTime',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'endTime' }
        },
        {
          title: '状态',
          dataIndex: 'status',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'createTime' }
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  created () {
    this.getList()
  },
  methods: {
    getList () {
      this.loading = true
      pageCouponActivity(this.queryParam).then(response => {
        const data = (response && response.data) || {}
        this.list = data.records || []
        this.total = data.total || 0
      }).finally(() => {
        this.loading = false
      })
    },
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery () {
      this.queryParam = {
        name: undefined,
        activityType: undefined,
        status: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = selectedRowKeys.length === 0
    },
    handleDelete (row) {
      const that = this
      const ids = row && row.id ? [row.id] : this.ids.slice()
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids.join(',') + '的数据',
        onOk () {
          return delCouponActivity(ids.map(id => ({ id }))).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('删除成功', 3)
          })
        }
      })
    },
    getActivityTypeLabel (value) {
      const target = this.activityTypeOptions.find(item => item.value === value)
      return target ? target.label : value || '-'
    },
    formatDateTime (value) {
      if (value === null || value === undefined || value === '') {
        return '-'
      }
      return this.parseTime(value) || value
    }
  }
}
</script>
